
const LandingHeroHeading = ({ children }) => {
    return (
        <p className='text-[30px] lg:text-[68px] leading-[38px] lg:leading-[76px] text-white text-center'>
            {children}
        </p>
    );
};

export default LandingHeroHeading;